app.directive('selectMultiple', ['$filter', '$timeout', function ($filter, $timeout) {
    return {
        restrict: 'EA',
        replace: true,
        transclude: true,
        require: '?ngModel',
        scope: {
            'title': '@',
            'datas': '=',
            'countTitle': '@',
            'classDropdown': '@',
            'mychange': '&',
            'ngChangeSearchtext': '&',
            'ngModel': '=?searchText',
            'filterbyactif2': '@'
        },
        templateUrl: "application/templates/directives/selectMultiple.html",

        controller: function ($scope) {
            $scope.$watch('datas', function () {
                $scope.countactif();
            });

            if (!$scope.filterbyactif2) {
                $scope.filterbyactif2 = false;
            }

            $scope.triggerChange = function () {
                $scope['ngModel'] = $scope.inputValue;
                if ($scope.ngChangeSearchtext) {
                    $scope.ngChangeSearchtext();
                }
            };

            $scope.addItem = function () {
                if ($scope.inputValue != "") {
                    $scope.datas.push({
                        name: $scope.inputValue,
                        actif: false
                    });
                    $scope.inputValue = "";
                }
            };

            $scope.config = {
                setHeight: 40 * ($scope.datas ? $scope.datas.length + 1 : 0)
            };


            $scope.orderByactif = function () {
                $scope.datas = $filter('orderBy')($scope.datas, ['-actif', 'name']);
                delete $scope.inputValue;
            };

            $scope.countactif = function () {
                $scope.count = 0;
                if ($scope.datas) {
                    $scope.datas.forEach(function (value) {
                        if (value.actif) {
                            $scope.count++;
                        }
                    });
                }
            };
            $scope.countactif();

            $scope.selectAll = function () {
                $scope.datas.forEach(function (value) {
                    value.actif = $scope.allSelected;
                    $scope.countactif();
                });
            };

            $scope.focusSearch = function (event) {
                $(event.currentTarget).closest(".select-multiple").find("input[type='text']").focus();
            }
        }
    }
}]);
